import { useAuth } from 'hooks/useAuth';
import { useQuery } from 'react-query';
import { getUserCurrentStore } from 'utils/authTyped';

import { getActiveLicense } from './services';

const ONE_MINUTE = 60000;

export function useActiveLicense() {
  const { isAuthenticated } = useAuth();
  const storeUuid = getUserCurrentStore()?.uuid;

  return useQuery({
    queryKey: ['active-license'],
    queryFn: () => getActiveLicense({ storeUuid }),
    refetchInterval: ONE_MINUTE,
    refetchIntervalInBackground: true,
    enabled: isAuthenticated,
    retry: 1,
    onSuccess: () => {
      // License gate disabled on this branch: no status forces a redirect to /subscription.
    },
  });
}
